import React from 'react';
import {StyledCheckbox, StyledPseudoCheckbox, StyledCheckboxWrapper, MultilineCheckboxLabel} from './styles';
import { CheckboxIcon } from '../icons/Checkbox';
import { ICheckboxProps } from './types';
import {TextButton, TextButton12} from '../globalStyles';
import { TypeInputRef } from '../input/types';
import Hint from "../hint";

const Checkbox: React.FC<ICheckboxProps> = React.forwardRef((props, ref: TypeInputRef) => {
	const { label, isInvalid, isRequired, isDisabled, helpMessage, multiline, ...rest } = props;

	return (
		<StyledCheckboxWrapper isInvalid={!!isInvalid} className='checkbox'>
			<StyledCheckbox {...rest} disabled={!!isDisabled} type='checkbox' required={isRequired} ref={ref} />
			<StyledPseudoCheckbox>
				<CheckboxIcon />
			</StyledPseudoCheckbox>
			{!!label && !multiline && <TextButton12>{label}{helpMessage && <Hint text={helpMessage}/>}</TextButton12>}
            {!!label && multiline && <MultilineCheckboxLabel>{label}</MultilineCheckboxLabel>}
		</StyledCheckboxWrapper>
	);
});

export default React.memo(Checkbox);
